module.exports = __webpack_public_path__ + "media/表1-8动画.58caf46b.mp4";